import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient';

export const useUserType = (userId: string | undefined) => {
  return useQuery({
    queryKey: ['userType', userId],
    queryFn: async () => {
      if (!userId) return { hasQuotes: false, hasCarrierRegistration: false };

      // Check if user has quotes
      const { data: quotes, error: quotesError } = await supabase
        .from('quotes')
        .select('id')
        .eq('user_id', userId)
        .limit(1);

      if (quotesError) throw quotesError;

      // Check if user has carrier registration
      const { data: carriers, error: carriersError } = await supabase
        .from('carrier_registrations')
        .select('id')
        .eq('user_id', userId)
        .limit(1);

      if (carriersError) throw carriersError;

      return {
        hasQuotes: (quotes?.length || 0) > 0,
        hasCarrierRegistration: (carriers?.length || 0) > 0
      };
    },
    enabled: !!userId,
    staleTime: 30000, // 30 seconds
    refetchInterval: 60000, // Refetch every minute
  });
};